import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./axiosInstance";

export const fetchUser = createAsyncThunk('user/fetchUser',
    async (_ , {rejectWithValue}) => {
        try {
            const response = await axiosInstance.get('/user/me');
            return response.data;
        }
        catch (error){
            return rejectWithValue(error.response.data.message)
        }
    });
    export const changePassword = createAsyncThunk(
        "auth/changePassword",
        async ({ oldPassword, newPassword }, { rejectWithValue }) => {
            console.log(oldPassword, newPassword)
          try {
            const response = await axiosInstance.post("/user/edit-password", {
              oldPassword,
              newPassword,
            });
            return response.data;
          } catch (error) {
            console.log(error)
            return rejectWithValue(
                [error.response.data.message] || error.response.data.errors 

            );
          }
        }
      );
      export const editProfile = createAsyncThunk("user/editProfile",
        async (data , {rejectWithValue}) => {
            try {
                const response = await axiosInstance.put("/user/edit-profile", data);
                return response.data;
            }
            catch (error){
              console.error("Erreur API :", error.response?.data || error.message);
                return rejectWithValue(error.response.data.message)
            }
        });
        export const fetchCustomer = createAsyncThunk("user/fetchCustomer",
          async (_ , {rejectWithValue}) => {
              try {
                  const response = await axiosInstance.get("/user/customer");
                  return response.data;
              }
              catch (error){
                  return rejectWithValue(error.response.data.message)
              }
          });